var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-430"},[_c('div',{staticClass:"header-wrapper-430"},[_c('NotesListSearch',{on:{"on-search":_vm.onSearch}})],1),_c('div',{staticClass:"table-wrap"},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.tableList,"border":"","loading":_vm.loading,"max-height":_vm.tableHeight},scopedSlots:_vm._u([{key:"orgId",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v("\n        "+_vm._s(row.orgId || '--')+"\n      ")]}},{key:"orgName",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('TablePoptip',{attrs:{"content":row.orgName}})]}},{key:"acctNo",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v("\n        "+_vm._s(row.acctNo || '--')+"\n      ")]}},{key:"acctName",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [(row.acctName)?_c('div',[_c('TablePoptip',{attrs:{"content":row.acctName}})],1):_c('span',[_vm._v("--")])]}},{key:"configName",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('TablePoptip',{attrs:{"content":row.configName}})]}},{key:"inAcctType",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v("\n        "+_vm._s(_vm.inAcctTypeObj[row.inAcctType] || '-')+"\n      ")]}},{key:"enable",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [(row.enable == 1)?_c('span',{staticStyle:{"color":"#19be6b"}},[_vm._v("开启")]):_c('span',{staticStyle:{}},[_vm._v("已关闭")])]}},{key:"accountingType",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [(row.accountingType == 1)?_c('span',[_vm._v("按月考勤节次")]):_vm._e(),(row.accountingType == 2)?_c('span',[_vm._v("按固定时长")]):_vm._e()]}}])})],1),_c('div',{staticClass:"page-wrap"},[_c('Page',{attrs:{"current":_vm.pageInfo.pageNum,"total":_vm.pageInfo.total,"page-size":_vm.pageInfo.pageSize,"show-total":"","show-elevator":"","show-sizer":"","page-size-opts":_vm.pageSizeOpts},on:{"on-change":_vm.pageChange,"on-page-size-change":_vm.handleSizeChange}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }